import styled from 'styled-components';

export const CredCockpitContainer = styled.div`
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  font-size: 14px;
  overflow-x: auto;
  
  table {
    min-width: 100%;
    border-collapse: collapse;
    border-radius: 4px;
  }

  th, td {
    padding: 16px 20px;
    text-align: left;
    border-bottom: 1px solidrgb(220, 132, 132);
  }

  th {
    background-color: #f5f5f5;
    font-weight: 600;
    color: #333;
    font-size: 14px;
  }

  td {
    font-size: 16px;
  }

  tr:hover {
    background-color: #f9f9f9;
  }
`;

export const CredCockpitHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const CredCockpitTitle = styled.h1`
  font-size: 24px;
  color: #333;
  margin: 0;
`;

export const CredCockpitFilter = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const CredCockpitFilterInput = styled.input`
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #0078d4;
    box-shadow: 0 0 0 2px rgba(0, 120, 212, 0.1);
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-end;
  padding: 20px;
  background: #FFFFFF;
  border-radius: 4px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 200px;
  flex: 1;
`;

export const FilterLabel = styled.label`
  font-size: 14px;
  color: #666;
  font-weight: normal;
`;

export const FilterSelect = styled.select`
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background: white;
  color: #333;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;

  &:focus {
    outline: none;
    border-color: #0078d4;
    box-shadow: 0 0 0 2px rgba(0, 120, 212, 0.1);
  }
`;

export const ClearButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.2s;
  height: 36px;
  align-self: flex-end;
  background-color: #1E2D3F;
  color: #FFFFFF;
  &:hover {
    background: #2E415C;
    color: #FFFFFF;
  }
`;

export const AutocompleteList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const AutocompleteItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f5f5f5;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: #666;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
`;

export const TableResponsiveWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;